export default class RolesPresenter {
  static AdminRoleSet = [
    'admin',
    'mm_edit', 'mm_create_datasheet', 'mm_approve_datasheet',
    'blh_edit', 'blh_create_datasheet', 'blh_approve_datasheet'
  ];

  normalizeRoles(changedRole, roles) {
    if (changedRole === 'admin' && !roles?.includes('admin'))
      return RolesPresenter.AdminRoleSet;

    const unassignedRoles = ['admin'];
    if (changedRole.includes('_view'))
      unassignedRoles.push(`${changedRole.split('_').shift()}_edit`);
    if (changedRole.includes('_edit'))
      unassignedRoles.push(`${changedRole.split('_').shift()}_view`);

    return this.normalizeRolesHelper(changedRole, roles, unassignedRoles);
  }

  normalizeRolesHelper(changedRole, roles, unassignedRoles) {
    const result = [...roles];

    const roleIndex = result.indexOf(changedRole);
    if (~roleIndex)
      result.splice(roleIndex, 1);
    else
      result.push(changedRole);

    unassignedRoles.forEach(r => {
      const unassignedIndex = result.indexOf(r);
      if (~unassignedIndex)
        result.splice(unassignedIndex, 1);
    });

    return result;
  }
}
